module.exports = __webpack_public_path__ + "img/case43.b6a594fa.png";